export default "__VITE_ASSET__By8N7CYY__"